
                  export default function (Component) {
                      Component.__source = "library/components/VabHeader/index.vue"
                  }
              